








import { defineComponent } from "@vue/composition-api"

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: "12px",
    },
    color: {
      type: String,
    },
  },
  setup() {
    return {}
  },
})
